import { useContext, useEffect, useState } from 'react'
import AppContext from '../context/app'
import { BASE_COUNTRY_ISO } from '../../constants'

export default function useGetPrice(product) {
    const { country, prices, promotions } = useContext(AppContext)
    const iso = country?.countryIso

    const [price, setPrice] = useState(null)
    const [baseprice, setBaseprice] = useState(null)

    const property = process.env.GATSBY_ENVIRONMENT_PRODUCTION === 'true' ?
        'pimcoreProductionId' :
        'pimcoreStagingId'

    useEffect(() => {
        if (!product || !prices || !promotions) return
        
        const id = product[property]
        if(!id) return
        
        const productPrice = prices[id]
        if(!productPrice) return
        
        const baseCountryPrice = productPrice[BASE_COUNTRY_ISO]
        setBaseprice(baseCountryPrice)

        const countryPrice = productPrice[iso]
        setPrice(countryPrice)
    }, [product, country, prices, promotions])
    
    return { price, baseprice }
}
